import React from 'react';

import {
  ActionButton,
  ContainerButtons,
  DeleteOutlined,
  SubTitle,
} from './styles';

const handleActions = (record, handleDeletarContato) => {
  const content = (
    <>
      <ActionButton
        type="link"
        aria-label="removeContatoButton"
        onClick={() => handleDeletarContato(record)}
      >
        <DeleteOutlined />
      </ActionButton>
    </>
  );

  return <ContainerButtons>{content}</ContainerButtons>;
};

export const getColumns = handleDeletarContato => {
  const columns = [
    {
      title: 'E-mail',
      dataIndex: 'contato',
      key: 'contato',
      width: '90%',
      align: 'left',
      render: (_, record) => (
        <SubTitle style={{ display: 'contents' }}>{`${record}`}</SubTitle>
      ),
    },
    {
      title: 'Ações',
      width: '10%',
      align: 'center',
      render: record => handleActions(record, handleDeletarContato),
    },
  ];

  return columns;
};
